import { onMounted, type Ref } from 'vue'

export const useUnfocus = (refElement: Ref<HTMLDivElement | null>, cb: () => void) => {
    onMounted(() => document.addEventListener('mousedown', checkFocus.bind(this)))
    const checkFocus = (event: MouseEvent) => {
        if (refElement.value && !refElement.value.contains(event.target as Node)) cb()
    }
}
